function loadJigsawHost(domain) {
  let scriptTag = document.createElement('script');
  const jigsawHost = `jigsaw.${domain}`;

  scriptTag.innerHTML = `Jigsaw.host = '${jigsawHost}';`;
  document.head.appendChild(scriptTag);
}

function checkMobile(innerWidth) {
  const mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
  const tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i
  
  const userAgent = navigator.userAgent;
  const isPhone = mobileRE.test(userAgent) || innerWidth <= 480;
  const isTablet = tabletRE.test(userAgent) || innerWidth <= 768;
  const isMobile = isTablet || isPhone;

  const mobileProps = {
    isMobile,
    isPhone,
    isTablet
  };

  return mobileProps;
}

async function parseUrlQuery() {
  const mobileProps = checkMobile(window.innerWidth);
  let query = {
    isMobile: mobileProps.isMobile,
    isTablet: mobileProps.isTablet,
    isPhone: mobileProps.isPhone,
    data: {}
  };
  let queryParams;
  let params;

  const vbid = window.location.pathname;
  if (vbid === '/') {
    queryParams = window.location.search.split('?').slice(1).join('&').split('&');
  } else {
    queryParams = window.location.search.split('?')[1].split('&');
    queryParams.push(`vbid=${vbid.slice(1)}`);
  }

  for (params of queryParams) {
    const keyValue = params.split('=');
    const key = keyValue[0].replace('custom_', '');

    query.data[key] = keyValue[1];
  }

  //load Jigsaw.host
  loadJigsawHost(query.data.ro);

  return query;
}


export default parseUrlQuery;
